import {DerivedPromotions} from './types';

/**
 * Shared "no result" shape. One literal so a ninth collection can't drift
 * between the two copies that need it:
 * - `usePromotions.ts` — query `data` is `undefined` while `enabled: false`
 *   (no storeNumber).
 * - `promotionsAccess.ts` — `ensurePromotions` returns this instead of
 *   calling `queryClient.ensureQueryData` with no storeNumber (see the guard
 *   comment there for why that call can't simply be skipped for other
 *   reasons).
 */
export const EMPTY_DERIVED_PROMOTIONS: DerivedPromotions = {
  rawPromotions: [],
  promotions: [],
  activePromotions: [],
  carouselData: [],
  feedData: [],
  drawnWinnersPromotions: [],
  listedECommerceOnlyPromotions: [],
  deepLinkOnlyPromotions: [],
};
